import { render, staticRenderFns } from "./CoozzyForm.vue?vue&type=template&id=4c873dd3&scoped=true"
import script from "./CoozzyForm.vue?vue&type=script&lang=js"
export * from "./CoozzyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c873dd3",
  null
  
)

export default component.exports